import { render } from "./SignalsView.vue?vue&type=template&id=d1a676c2&scoped=true"
import script from "./SignalsView.vue?vue&type=script&lang=js"
export * from "./SignalsView.vue?vue&type=script&lang=js"

import "./SignalsView.vue?vue&type=style&index=0&id=d1a676c2&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a676c2"]])

export default __exports__